<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<n-slide-window *ngIf="pageReady"
    [visible]="windowVisible"
    [width]="'6.08rem'"
    id="create-file-share-slide-window"
    [loading]="loading"
    (onHide)="close()"
    (onShow)="onShow()">
    <n-header>
        <h1>{{i18n.createFileShareTitle}}</h1>
        <n-help-link key="simplifyshareCreate"></n-help-link>
    </n-header>

    <form [errorMessage]="errorMessage"
        [formGroup]="vm"
        [simpleMode]="true">
        <!-- 无pool提示-->
        <n-form-item labelHide="true"
            class="no-pool-message-tip"
            *ngIf="showNoPoolMessageTip && !vm.value.storagePool">
            <app-message-tip
                id="no_pool_message_tip_id"
                [type]="noPoolMessageTip.type"
                [contentHandler]="noPoolMessageTip.contentHandler"
                [showCloseBtn]="false"
                [simpleMode]="true">
            </app-message-tip>
        </n-form-item>
        <!-- 选择创建方式 -->
        <n-form-item [labelHide]="true" *ngIf="!fileSystem?.NAME">
            <div class="title-md">
                <div class="step-number"><span>1</span></div>
                {{i18n.selecteCreateTypeTitle}}
            </div>
        </n-form-item>
        <n-form-item [labelHide]="true" *ngIf="!fileSystem?.NAME">
            <n-radio-group formControlName="createFileShareType"
                [cardStyle]="true"
                (onChange)="createFileShareTypeChange($event)">
                <n-radio id="create-file-share-new-id"
                    [value]="CreateFileShareTypeE.NEW"
                    [icon]="'#app-icon-file-share-recommended'"
                    [title]="i18n.fastCreateFileShareTitle"
                    [tip]="i18n.fastCreateFileShareInfo"
                    [recommendedConfigTitle]="i18n.recommendedConfigTitle"
                    [ngStyle]="{'width': multiTitleWidth}">
                </n-radio>
                <n-radio id="create-file-share-exist-id"
                    [value]="CreateFileShareTypeE.EXIST"
                    [icon]="'#app-icon-file-share-choosen'"
                    [title]="i18n.selectFileSystemCreateShareTitle"
                    [tip]="i18n.selectFileSystemCreateShareInfo"
                    [ngStyle]="{'width': multiTitleWidth}">
                </n-radio>
            </n-radio-group>
        </n-form-item>
        <!-- 文件系统 -->
        <n-form-item [label]="i18n.fileSystem" [class.hidden]="vm.value.createFileShareType === CreateFileShareTypeE.NEW">
            <ng-container *ngIf="canFileSystemChange; else fsText">
                <n-select #fsSelect
                    id="create-file-share-fs"
                    [filter]="true"
                    formControlName="FS"
                    [optionsFactory]="fsOptionsFactory"
                    (onChange)="onChooseFileSystem($event)">
                </n-select>
            </ng-container>
            <ng-template #fsText>
                <div class="n-form-item-text">{{fileSystem?.NAME || UNPLACEHOLDER}}</div>
            </ng-template>
            <ng-container *ngIf="fileSystemCreateShareExistStr &&
                (vm.value.FS || fileSystem?.NAME) &&
                (copyFromNfsShareS?.switch || copyFromCifsShareS?.switch && !hideCifsShare)">
                <span class="info-md" *ngIf="vm.value.createFileShareType === CreateFileShareTypeE.EXIST &&
                            selectedFilesystem?.isAuditLogFs">
                    {{nfsShareStrService.i18n.label.auditFs}}
                </span>
                <span class="info-md" *ngIf="copyFromNfsShareS?.isExistNfs">
                    {{i18n.existNfsShareLab}}
                </span>
                <span class="info-md" id="filesystem-create-share-exist-str-id">
                    {{fileSystemCreateShareExistStr}}
                </span>
                <ng-container *ngIf="!isRootDirectory">
                    <span class="info-md">{{i18n.ifNeedLab}}</span>
                    <button nButton
                        theme="text"
                        [label]="i18n.modifyShareNameBtn"
                        (click)="modifyShareName()">
                    </button>
                    <span class="info-md">{{i18n.configShareLab}}</span>
                </ng-container>
            </ng-container>
        </n-form-item>
        <!-- 名称 -->
        <n-form-item [label]="i18n.nameLab"
            [required]="true"
            *ngIf="vm.value.createFileShareType === CreateFileShareTypeE.NEW">
            <input type="text"
                id="create-file-system-name"
                nInput
                formControlName="name"
                [placeholder]="errorMessage.name.rangeByteLength">
            <span class="info-md" *ngIf="vm.value.name && (copyFromNfsShareS?.switch || copyFromCifsShareS?.switch)">
                {{fileSystemCreateShareNewStr}}
            </span>
        </n-form-item>
        <!-- 设置文件共享所需容量 -->
        <n-form-item [labelHide]="true" *ngIf="vm.value.createFileShareType === CreateFileShareTypeE.NEW">
            <div class="title-md mt-24">
                <div class="step-number"><span>2</span></div>
                {{i18n.settingShareNeedCapacityTitle}}
            </div>
        </n-form-item>
        <n-form-item [label]="i18n.capacityLab"
            [helpContent]="i18n.createCapacityTip"
            required="true"
            *ngIf="vm.value.createFileShareType === CreateFileShareTypeE.NEW">
            <div class="interval-10">
                <n-capacity id="create-file-system-capacity"
                    [units]="['Sector', 'MB', 'GB', 'TB', 'PB']"
                    [nonDecimalUnits]="['Sector', 'MB']"
                    formControlName="capacity">
                </n-capacity>
            </div>
            <div *ngIf="vm.value.capacity?.unit === 'Sector'" class="capacity-show-info" id="capacity-show-info-id">
                <span>
                    {{ vm.value.capacity?.value | adaptUnit :'Sector'}}
                </span>
            </div>
            <n-tip *ngIf="capLossTips"
                [content]="capLossTips">
            </n-tip>
        </n-form-item>
        <!-- 高级设置-->
        <n-collapse-list id="simple-advance-setting-collapse"
            [title]="i18n.advancedSettingTitle"
            [autoActive]="vm.value.createFileShareType === CreateFileShareTypeE.EXIST"
            class="simple-advance-setting-collapse">
            <!-- 共享协议 -->
            <ng-container *ngIf="hasSharePermission">
                <n-form-item class="mt-8"
                    [labelHide]="true">
                    <div class="form-title-bold">{{i18n.shareProtocolTitle}}</div>
                    <span class="info-md">
                        {{i18n.shareProtocolInfo}}
                    </span>
                </n-form-item>
                <n-form-item labelHide="true" class="form-item-no-mb">
                    <app-copy-from-nfs-share-s
                        #copyFromNfsShareS
                        [vm]="vm"
                        [entry]="(vm.value.createFileShareType === CreateFileShareTypeE.EXIST && copyFromShareEntry) ? copyFromShareEntry : undefined"
                        [fsName]="vm.value.name"
                        [shareSwitch]="shareSwitch.nfs"
                        [smartGuiNfs]="smartGuiNfs"
                        [vstoreName]="selectedVstore?.label"
                        [vstoreId]="selectedVstore?.value"
                        [supportSmartGui]="copyFromShareEntry != FileSystemEntryE.AuditLog"
                        [isExistNfs]="!!shareResult?.NFS"
                        [fileSystem]="(vm.value.createFileShareType === CreateFileShareTypeE.EXIST && selectedFilesystem) ? selectedFilesystem : undefined"
                        [shareSwitch]="shareEntry !== ShareEntryE.CIFS"
                        [supportConfigPermission]="!(vm.value.createFileShareType === CreateFileShareTypeE.EXIST &&
                            selectedFilesystem && selectedFilesystem.ID === GlobalNamespaceE.ID)"
                        (nfsShareSwitchUpdate)="nfsShareSwitchUpdate()"
                        (nfsSharePermissionUpdate)="nfsSharePermissionUpdate()">
                    </app-copy-from-nfs-share-s>
                </n-form-item>
                <n-form-item labelHide="true" class="form-item-no-mb mt-16" [class.hidden]="hideCifsShare" *ngIf="!ProductConfig.isHideCifs">
                    <app-copy-from-cifs-share-s
                        #copyFromCifsShareS
                        [vm]="vm"
                        [entry]="(vm.value.createFileShareType === CreateFileShareTypeE.EXIST && copyFromShareEntry) ? copyFromShareEntry : undefined"
                        [fsName]="vm.value.name"
                        [shareSwitch]="shareSwitch.cifs"
                        [smartGuiCifs]="smartGuiCifs"
                        [vstoreName]="selectedVstore?.label"
                        [vstoreId]="selectedVstore?.value"
                        [supportSmartGui]="copyFromShareEntry != FileSystemEntryE.AuditLog"
                        [fileSystem]="(vm.value.createFileShareType === CreateFileShareTypeE.EXIST && selectedFilesystem) ? selectedFilesystem : undefined"
                        [shareSwitch]="shareEntry !== ShareEntryE.NFS"
                        (sendShareNameChangedData)="getShareNameChangedData($event)"
                        (cifsShareSwitchUpdate)="cifsShareSwitchUpdate()"
                        (cifsSharePermissionUpdate)="cifsSharePermissionUpdate()">
                    </app-copy-from-cifs-share-s>
                </n-form-item>
                <n-form-item labelHide="true" *ngIf="(!copyFromNfsShareS?.switch || shareResult?.NFS) && (!copyFromCifsShareS?.switch || hideCifsShare)">
                    <n-tip type="failed" [content]="i18n.needOneShareTip">
                    </n-tip>
                </n-form-item>
            </ng-container>

            <!-- 数据保护 -->
            <ng-container *ngIf="supportCdpSchedule && vm.value.createFileShareType === CreateFileShareTypeE.NEW">
                <n-form-item [labelHide]="true" class="mt-16">
                    <div class="form-title-bold form-title-bottom">{{i18n.dataProtectTitle}}</div>
                </n-form-item>

                <n-form-item [labelHide]="true" class="form-item-no-mb">
                    <div class="copy-from-share-simple">
                        <div slot="title" class="copy-from-switch">
                            <h2 class="card-title">{{i18n.cdpScheduleTitle}}</h2>
                            <n-switch id="create-file-share-add-to-cdp-switch"
                                formControlName="addToCdpScheduleSwitch"
                                (onChange)="cdpScheduleSwitchChange($event)">
                            </n-switch>
                        </div>
                    </div>
                </n-form-item>

                <!-- CDP计划 -->
                <n-form-item *ngIf="vm.value.addToCdpScheduleSwitch"
                    [labelHide]="true">
                    <!-- 添加策略按钮 -->
                    <div class="table-operation interval-10 mt-16 mb-16">
                        <n-button-group [items]="scheduleBtnGroup">
                        </n-button-group>
                    </div>
                    <n-data-card #nDataCard
                        id="cdp-schedule-data-card"
                        [config]="dataCardConfig"
                        [multiCardStyle]="true"
                        [showDefaultWhenNoData]="true"
                        [supportSelectedFirstData]="true"
                        [defaultData]="scheduleDefaultData"
                        [rest]="cdpScheduleRest"
                        formControlName="selectedCdpSchedule">
                    </n-data-card>
                </n-form-item>
            </ng-container>

            <!-- 存储池 -->
            <n-form-item *ngIf="storagePoolOpts?.length > 1 && vm.value.createFileShareType === CreateFileShareTypeE.NEW"
                [labelHide]="true">
                <div class="form-title-bold form-title-bottom">{{i18n.storagePoolTitle}}</div>
            </n-form-item>
            <n-form-item *ngIf="storagePoolOpts?.length > 1 && vm.value.createFileShareType === CreateFileShareTypeE.NEW"
                [label]="i18n.storagePoolLab"
                [required]="true">
                <n-select #poolSelect
                    id="create-file-system-storagepool"
                    [options]="storagePoolOpts"
                    formControlName="storagePool"
                    (onChange)="onStoragePoolChange($event)">
                </n-select>
            </n-form-item>

            <!-- 应用类型 -->
            <n-form-item [labelHide]="true" *ngIf="vm.value.createFileShareType === CreateFileShareTypeE.NEW">
                <div class="form-title-bold form-title-bottom">{{i18n.workloadTypeLab}}</div>
            </n-form-item>
            <n-form-item *ngIf="vm.value.createFileShareType === CreateFileShareTypeE.NEW"
                [label]="i18n.simpleModeWorkloadTypeLab"
                [required]="true">
                <n-select id="create-file-share-workload-type"
                    [options]="workloadTypeOpts"
                    formControlName="workloadType"
                    (onChange)="onWorkloadTypeChange($event)">
                </n-select>
                <ng-container *ngIf="selectedWorkloadType">
                    <div class="selected-workload-type-main">
                        <div class="selected-workload-type-boder">
                            <div class="selected-workload-type-content">
                                <p class="sub mt-5">{{i18n.typeLab}}</p>
                                <p class="sub mt-5 selected-workload-type-value">{{workloadCreateTypeMap[selectedWorkloadType.CREATETYPE]}}</p>
                            </div>
                            <ng-container *ngIf="!isOceanProtectXseriesDevice && !isOceanProtectAseriesDevice">
                                <div class="selected-workload-type-content">
                                    <p class="sub mt-5">{{i18n.requestSizeInfoLabWithColon}}</p>
                                    <p class="sub mt-5 selected-workload-type-value">{{blockSizeE[selectedWorkloadType.BLOCKSIZE]}}</p>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!supportGuaranteedCapacity || supportDedupeAndCompression">
                                <div class="selected-workload-type-content" *ngIf="showVariableSegment">
                                    <p class="sub mt-5">{{i18n.requestSizetVariable}}</p>
                                    <p class="sub mt-5 selected-workload-type-value">{{selectedWorkloadType.variableSegment + 'KB'}}</p>
                                </div>
                                <div class="selected-workload-type-content" *ngIf="!isCoverageStor">
                                    <p class="sub mt-5">{{i18n.smartCompressionLab}}</p>
                                    <p class="sub mt-5 selected-workload-type-value">{{selectedWorkloadType.ENABLECOMPRESS === 'true' ? i18n.enabledLab : i18n.disabledLab}}</p>
                                </div>
                                <div class="selected-workload-type-content" *ngIf="!isCoverageStor">
                                    <p class="sub mt-5">{{i18n.smartDedupLab}}</p>
                                    <p class="sub mt-5 selected-workload-type-value">{{selectedWorkloadType.ENABLEDEDUP === 'true' ? i18n.enabledLab : i18n.disabledLab}}</p>
                                </div>
                            </ng-container>
                            <div class="selected-workload-type-content">
                                <p class="sub mt-5">{{i18n.distributionAlgoLabel}}</p>
                                <p class="sub mt-5 selected-workload-type-value">{{utilService.getLabelFromOptions | fn :str.DistAlgOpts :selectedWorkloadType.distAlg}}</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </n-form-item>
        </n-collapse-list>
    </form>

    <n-footer>
        <button id="create-file-share-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button id="create-file-share-cancel-btn"
            nButton
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
